let dialogApi = null;

export function registerDialogApi(api) {
  dialogApi = api;
}

window.alert = async function (message) {
  if (!dialogApi) {
    console.warn("Dialog API not registered yet.");
    return;
  }

  await dialogApi.alert({
    title: "Notice",
    message: String(message || ""),
  });
};

window.confirm = async function (message) {
  if (!dialogApi) {
    console.warn("Dialog API not registered yet.");
    return false;
  }

  return await dialogApi.confirm({
    title: "Please confirm",
    message: String(message || ""),
    confirmText: "Confirm",
    variant: "danger",
  });
};

window.appPrompt = async function (options) {
  if (!dialogApi) {
    console.warn("Dialog API not registered yet.");
    return null;
  }

  return await dialogApi.prompt(options);
};

window.appSelect = async function (options) {
  if (!dialogApi) {
    console.warn("Dialog API not registered yet.");
    return null;
  }

  return await dialogApi.select(options);
};
